/* eslint-disable @typescript-eslint/naming-convention */
import { ReactElement } from 'react';
import { ChatMessage as OriginalChatMessage, CustomMessage as OriginalCustomMessage } from '@azure/communication-react';
import { Ad } from '../../Repository/BingSerp';

export interface ChatMessage extends OriginalChatMessage {
  isTheChosenCandidate?: boolean;
  isCandidateSelectEnd?: boolean;
  isCandidate?: boolean;
  replyToId?: string;
  deploymentName?: string;
  rate?: string;
  annotation?: string;
}

export interface CustomMessage extends OriginalCustomMessage {
  deploymentName?: string;
  annotation?: string;
}

export type messageProps = {
  message: ChatMessage | CustomMessage,
  messageContent: ReactElement,
  customClassName?: string,
  onLike?: (message: ChatMessage, liked: boolean) => void;
  onDislike?: (message: ChatMessage, disliked: boolean) => void;
  disableLike?: boolean;
  disableDislike?: boolean;
  isShowDeploymentName?: boolean;
  enableAnnotation?: boolean;
  onAnnotation?: (message: ChatMessage, annotation: string) => void;
  isUserMessage?: boolean;
};

export type chatMessageProps = {
  message: ChatMessage,
  onLike?: (message: ChatMessage, liked: boolean) => void;
  onDislike?: (message: ChatMessage, disliked: boolean) => void;
  disableLike?: boolean;
  disableDislike?: boolean;
  isShowDeploymentName?: boolean;
  enableAnnotation?: boolean;
  onAnnotation?: (message: ChatMessage, annotation: string) => void;
  isUserMessage?: boolean;
};

export type customMessageProps = {
  message: CustomMessage,
};

export enum CustomMessageType {
  ProdAds = 'ProdAds',
  TextAds = 'TextAds',
}

export type ICustomMessageContent = {
  type: CustomMessageType;
  response: string;
};

export type ProdAdsCustomMessage = {
  ads: Array<Ad>,
  content: string;
} & ICustomMessageContent;

export type TextAdsCustomMessage = {
  ads: Array<Ad>,
  content: string;
} & ICustomMessageContent;

export interface IMultiDeploymentChatHistoryChatBotRecord {
  name: string | undefined;
  response: string | undefined;
  selected: boolean;
  rate: string | undefined;
  annotation: string | undefined;
}

export interface IMultiDeploymentChatHistoryItem {
  user: string | undefined;
  chatbots: IMultiDeploymentChatHistoryChatBotRecord[]
}

export interface IMultiDeploymentChatHistory {
  conversation: IMultiDeploymentChatHistoryItem[]
}
